import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Category, Intercalaire, Patient} from '../../_models';
import {first} from 'rxjs/operators';
import {IntercalaireService} from '../../_services';
import {getCurrentAbeille} from '../../../assets/utils.js';

@Component({
  selector: 'app-create-intercalaire',
  templateUrl: './create-intercalaire.component.html',
  styleUrls: ['./create-intercalaire.component.scss']
})
export class CreateIntercalaireComponent {

    @Input() intercalaire: Intercalaire;
    @Output() refreshEvent = new EventEmitter<Intercalaire>();
    patientId = '';
    errors = [];

    intercalaireForm = new FormGroup({
        name: new FormControl(''),
    });

    colors = [
        '#E83D5B',
        '#1494C3',
        '#E36900',
        '#D3577D',
        '#70F79A',
        '#FACAD3',
        '#42C33D',
        '#B875FA',
        '#2939FF',
        '#BEC0FF',
        '#FFA0FB',
        '#FFAA84',
    ]

    selectedColor = 0;

    constructor(private intercalaireService: IntercalaireService) {
        this.patientId = getCurrentAbeille().id;
    }

    selectColor(i) {
      this.selectedColor = i;
    }

    findColorIndex(color) {
        this.colors.forEach((value, index) => {
            if (color === value) {
                this.selectedColor = index;
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {

        if (this.intercalaire) {
            this.intercalaireForm = new FormGroup({
                name: new FormControl(this.intercalaire.name),
            });

            this.findColorIndex(this.intercalaire.color);
        }
    }

    submit() {

        if (this.intercalaire) { // update existing intercalaire
            this.errors = [];
            let isOK = true;

            if (this.intercalaireForm.value.name == '') {
              this.errors[`name`] = true;
              isOK = false;
            }

            if (!isOK) {
              return;
            }

            this.intercalaire.name = this.intercalaireForm.value.name;
            this.intercalaire.color = this.colors[this.selectedColor];

            this.intercalaireService.update(this.intercalaire).pipe(first()).subscribe(result => {
                this.intercalaireForm.reset();
                this.selectedColor = 0;
                this.refreshEvent.next(result as Intercalaire);
            });
        } else { // create new intercalaire
            const intercalaire = new Intercalaire({});
            intercalaire.name = this.intercalaireForm.value.name;

            this.errors = [];
            let isOK = true;

            if (intercalaire.name == '') {
              this.errors[`name`] = true;
              isOK = false;
            }

            if (!isOK) {
              return;
            }

            intercalaire.color = this.colors[this.selectedColor];

            this.intercalaireService.registerByPatientId(this.patientId, intercalaire).pipe(first()).subscribe(result => {
                this.intercalaireForm.reset();
                this.selectedColor = 0;
                this.refreshEvent.next(result as Intercalaire);
            });
        }
    }

}
